export default "__VITE_ASSET__BYLzs_Yv__"